/**
 * Response header our backend sets on a `503` when the downtime is our own
 * planned maintenance, as opposed to an external/infrastructure outage that
 * carries no such marker.
 *
 * The side is told apart by the header's presence alone, not its value: the
 * backend contract does not fix a value, so any non-empty one counts.
 */
export const MAINTENANCE_HEADER = 'X-Maintenance';
